import MyWorkAppApi from './MyWorkAppApi'
import * as config from '../config.js'
var Api = new MyWorkAppApi({
  url: config.API_ROOT
})

export default Api
